import * as Yup from "yup";

export const DepartmentFormValidation = Yup.object({
    code: Yup.string()
        .required("Code is required")
        .min(1)
        .max(50),
    description: Yup.string()
        .required("Description is required")
        .min(1)
        .max(150),
    departmentLevelId: Yup.string()
        .required("Department Level is required"),
    parentDepartmentId: Yup.string()
        .optional(),
    departmentHeadId: Yup.string()
        .optional(),
    color: Yup.string()
        .matches(/^#[0-9A-Fa-f]{6}$/, {
            message: "Must be a hex colour like #1A2B3C",
            excludeEmptyString: true,
        })
        .optional(),
});
